import { ICommand } from 'core-ts-types';
import { AccountIdentityDatastore } from 'data-ng-authentication';
import { IAPComponentStateModel } from '../global/models/ap_component_state_model';
import { FeedbackSuggestedPlanModel } from '../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from '../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { LoadProgramAndTermsDataCommand } from './../suggestions/commands/load_program_and_terms_data_command';
import { courseDetailState } from './ap_course_details_routes';

const modalStudentView = 'modal@my.planner.suggestions';

export const ApPlanFeedbackRoutes = {
  'my.planner.suggestions': <ng.ui.IState>{
    url: 'suggestions/',
    template: `
            <div class="plan-feedback-section clr-gray_20-bkg">
            <plan-feedback l-size="grow" l-hug="center"></plan-feedback>
            <ui-view name="right-panel-popout" class="right-drawer"></ui-view>
            <ui-view name="modal"></ui-view>
          </div>
            `,
    onEnter: (ngAPComponentStateModel: IAPComponentStateModel) => {
      ngAPComponentStateModel.studentFeedbackTerms.splice(0);
    },
    data: {
      pageTitle: 'Suggestions'
    },
    resolve: {
      accountModeConfig: (loadAccountCommand: ICommand) => loadAccountCommand(),
      termsAndProgram: (loadProgramAndTermsDataCommand: LoadProgramAndTermsDataCommand) =>
        loadProgramAndTermsDataCommand(),
      comment: (
        advisorSuggestedPlan: ICommand,
        loadCommentCommand: ICommand,
        ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
      ) =>
        loadCommentCommand(
          `/academicplan/suggested_plan/${ngFeedbackSuggestedPlanModel.read().id}/comment/?modified=true`
        ),
      advisorSuggestedPlan: (accountModeConfig: any, loadSuggestedPlanStatusCommand: ICommand) =>
        loadSuggestedPlanStatusCommand(),
      loadConflicts: (
        advisorSuggestedPlan: ICommand,
        loadBlockedSuggestionsCommand: ICommand,
        loadPlanFeedbackCommand: ICommand,
        ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
      ) => {
        return PlanFeedbackServant.isPlanBlocked(ngFeedbackSuggestedPlanModel.read())
          ? loadBlockedSuggestionsCommand()
          : loadPlanFeedbackCommand();
      }
    }
  },
  'my.planner.suggestions.course_details': {
    ...courseDetailState,
    views: {
      'right-panel-popout@my.planner.suggestions': {
        template: `<ap-course-details></ap-course-details>`
      }
    }
  },
  'my.planner.suggestions.linked_suggestions': {
    views: {
      [modalStudentView]: {
        template: `<linked-suggestion-action-popup></linked-suggestion-action-popup>`
      }
    }
  },
  'my.planner.suggestions.advisor_revoked_changes': {
    data: {
      pageTitle: 'Advisor revoked suggestions'
    },
    views: {
      [modalStudentView]: {
        template: `<plan-feedback-revoked-popup></plan-feedback-revoked-popup>`
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_plan_feedback_routes.ts